import { useState, useEffect } from 'react';

const screenResolution = () => {
  const [resolution, setResolution] = useState('');

  const checkResolution = () => {
    const w = window.innerWidth;

    if (w < 768 && resolution !== 'mobile') {
      setResolution('mobile');
    }

    if (w > 767 && resolution !== 'desktop') {
      setResolution('desktop');
    }
  };

  useEffect(() => {
    checkResolution();
    window.addEventListener('resize', checkResolution);

    return (() => {
      window.removeEventListener('resize', checkResolution);
    });
  }, []);

  return resolution;
};

export default screenResolution;
